// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nYTD","footer":"styles_footer__1x2EP"};